import { GetChangeTypeIconProps } from "@/appComponents/Navigation/RightSidebar/Planning/Activity/Activity.utils";
import ToolbarPopover from "@/appComponents/Navigation/ContextualToolbar/ToolbarPopover/ToolbarPopover";
import { Flex, Icon, Text, ToolIcon } from "@theorgchartdev/storybook";
import { ChangeDisplayRow } from "@/appComponents/Blocks/Composites/ChangeDisplayRow/ChangeDisplayRow";
import React, { useRef } from "react";
import { GetDoc, GetWSMgr } from "@/Utils/StateLib";

export const ChangePopover = ({ reference, displayLabel, override, isTableChange }) => {
  const change = override.lastActiveChange();
  const changeType = override.SmartGetFieldValue("Type");
  const iconProps = { ...GetChangeTypeIconProps(changeType), size: "small" };
  const ctrlRef = useRef(null);
  const wsMgr = GetWSMgr();
  const doc = GetDoc();

  return (
    <ToolbarPopover
      overlayProps={{ sizeProps: { minWidth: 160, maxWidth: 300, minHeight: 50, maxHeight: 300 } }}
      otherPopoverProps={{
        offsetOptions: -2,
        referenceProps: { onClick: e => e.stopPropagation() },
        reference: reference
      }}
      openCtrlRef={ctrlRef}
      key={5}
      placement={"top-start"}
      iconOnly={true}
      className={"oc-change-details-popover"}
    >
      <Flex gap={"8px"} direction={"column"}>
        <Flex justifyContent={"space-between"} alignItems={"flex-start"}>
          <Flex gap={"8px"}>
            <Icon {...iconProps} />
            <Text size={"small"} modifier={"medium"}>
              {displayLabel}
            </Text>
          </Flex>
          <Flex>
            <ToolIcon
              onClick={() => ctrlRef.current.setOpen(false)}
              name={"xmark"}
              size={"xsmall"}
              shape={"round"}
            />
          </Flex>
        </Flex>
        <Flex direction={"column"} gap={"8px"} style={{ paddingLeft: "12px" }}>
          <ChangeDisplayRow
            change={change}
            showCommentBubble={true}
            changeIndex={0}
            tableView={isTableChange}
            doc={doc}
            wsMgr={wsMgr}
          />
        </Flex>
      </Flex>
    </ToolbarPopover>
  );
};
